import React from 'react';
import { Download, Clock, Calendar } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const ExportCategory = ({ category, onExport }) => {
  const Icon = category?.icon;

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all">
      <div className="flex items-start justify-between mb-4">
        <div className="p-3 bg-blue-100 rounded-lg">
          <Icon className="w-6 h-6 text-blue-600" />
        </div>
        <button
          onClick={() => onExport(category)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
        >
          <Download className="w-4 h-4" />
          Export
        </button>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{category?.title}</h3>
      <p className="text-sm text-gray-600 mb-4">{category?.description}</p>
      <div className="space-y-3">
        <div className="flex items-center gap-2 text-sm">
          <span className="text-gray-600">Formats:</span>
          <div className="flex gap-2">
            {category?.formats?.map(format => (
              <span key={format} className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium">
                {format}
              </span>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Clock className="w-4 h-4" />
          <span>Est. Time: {category?.estimatedTime}</span>
        </div>

        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Calendar className="w-4 h-4" />
          <span>Last exported: {category?.lastExported || 'Never'}</span>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200">
        <p className="text-xs text-gray-500 mb-2">Included Fields:</p>
        <div className="flex flex-wrap gap-1">
          {category?.fields?.slice(0, 3)?.map((field, idx) => (
            <span key={idx} className="text-xs px-2 py-1 bg-gray-50 text-gray-600 rounded">
              {field}
            </span>
          ))}
          {category?.fields?.length > 3 && (
            <span className="text-xs px-2 py-1 bg-gray-50 text-gray-600 rounded">
              +{category?.fields?.length - 3} more
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExportCategory;